import { gsap } from "gsap";

const LogosTiles = () => {
	const block = document.querySelectorAll(".logos-tiles_ticker");
	if (!block) {
		return;
	}
	block.forEach((el) => {
		const list = el.querySelector(".logos-tiles__list");

		const wrapped = "<div class='logos-tiles__row'>" + list.innerHTML + "</div>";
		list.innerHTML = wrapped;
		const row = list.querySelector(".logos-tiles__row");
		list.append(row.cloneNode(true));

		gsap.to(list, {
			x: -row.offsetWidth,
			repeat: -1,
			duration: 60,
			ease: "none"
		})
	});
};

export default LogosTiles;
